var textField = document.getElementById("personalization-text-area");
var addToCartButton = document.querySelector(".product-form--atc-button");

function displayWarning(e) {
  var textContent = textField.value;
  if(textContent.length < 1) {
    e.preventDefault();
    textField.style.border = '2px dashed red';
    window.alert ("Please fill out the 'Personalization' field");
  } else {
    textField.style.border = '1px solid black';
  }
}

addToCartButton.addEventListener("click", displayWarning); 
